/**
 * Floating overlay surfaces (menus, popovers, dialogs, DataGrid panels).
 * Shadows use --tw-shadow-* tokens, not MUI Paper elevation.
 */
export const muiOverlayPaperSurface = {
  boxShadow: 'var(--tw-shadow-overlay)',
  border: 'none',
  backgroundImage: 'none',
};

export const muiOverlayDialogPaperSurface = {
  boxShadow: 'var(--tw-shadow-overlay-lg)',
  border: 'none',
  backgroundImage: 'none',
};

/** v4 `props` / v5 `defaultProps` — scroll the page behind the dialog, not the paper. */
export const muiDialogDefaultProps = {
  scroll: 'body',
};

/**
 * GridPanel Paper uses elevation={8}; MuiPaper elevation + default shadow styles
 * beat a plain MuiDataGrid `paper` override on specificity / injection order.
 */
export const muiDataGridPanelPaperSurface = {
  boxShadow: 'var(--tw-shadow-overlay) !important',
  border: 'none !important',
  backgroundImage: 'none',
  '&&': {
    boxShadow: 'var(--tw-shadow-overlay) !important',
    border: 'none !important',
    backgroundImage: 'none',
  },
  '&.MuiPaper-root.MuiPaper-elevation8': {
    boxShadow: 'var(--tw-shadow-overlay) !important',
    border: 'none !important',
    backgroundImage: 'none',
  },
};

/**
 * Nested under MuiPaper `elevation8` (same element as `.MuiDataGrid-paper`).
 */
export const muiPaperElevation8DataGridPanel = {
  '&.MuiDataGridPanel-paper': muiDataGridPanelPaperSurface,
  '&.MuiDataGridPanel-paper .MuiPaper-root': muiDataGridPanelPaperSurface,
};

/** @type {import('@mui/material/styles').Components} */
export const muiOverlayComponentsV5 = {
  MuiMenu: {
    styleOverrides: {
      paper: muiOverlayPaperSurface,
    },
  },
  MuiPopover: {
    styleOverrides: {
      paper: muiOverlayPaperSurface,
    },
  },
  MuiAutocomplete: {
    styleOverrides: {
      paper: muiOverlayPaperSurface,
    },
  },
  MuiDialog: {
    defaultProps: muiDialogDefaultProps,
    styleOverrides: {
      paper: muiOverlayDialogPaperSurface,
    },
  },
  MuiDataGrid: {
    styleOverrides: {
      root: {
        '.MuiCard-root &': {
          border: 0,
          borderWidth: 0,
        },
      },
      paper: muiDataGridPanelPaperSurface,
    },
  },
};

export const muiOverlayOverridesV4 = {
  MuiMenu: {
    paper: muiOverlayPaperSurface,
  },
  MuiPopover: {
    paper: muiOverlayPaperSurface,
  },
  MuiAutocomplete: {
    paper: muiOverlayPaperSurface,
  },
  MuiDialog: {
    paper: muiOverlayDialogPaperSurface,
  },
  MuiDataGrid: {
    root: {
      '.MuiCard-root &': {
        border: 0,
        borderWidth: 0,
      },
    },
    paper: muiDataGridPanelPaperSurface,
  },
};
